// Serenity Star API Configuration for DFS Collections Agent Portal
export const API_BASE_URL = 'https://api.serenitystar.ai';
export const API_KEY = '3e0cac9e-2627-4227-8aea-c6d123cd6ac5';
export const SUBTENANT_ID = '18753294-16d5-fa48-b016-3a1f18d8ad82';
export const DATASET_ID = 'ecb704e4-044c-4489-b9be-bb60c177a0e8';

// API Config object for compatibility
export const API_CONFIG = {
  baseUrl: API_BASE_URL,
  apiKey: API_KEY,
  subtenantId: SUBTENANT_ID,
  datasetId: DATASET_ID,
};

// Agent Codes for DFS Collections
export const AGENT_CODES = {
  CHATBOT: 'dfs-chatbot',
  SEGMENTADOR: 'dfs-segmentador',
  COMUNICADOR: 'dfs-comunicador',
  ANALIZADOR: 'dfs-analizador',
  EVALUADOR: 'dfs-evaluador',
  JUDICIAL: 'dfs-judicial',
  VALIDADOR: 'dfs-validador',
};

// Environment configuration
export const ENV = {
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
};
